import { DecisionsTypeArray } from "components/Reports/reportAssets/assets";
import { useGetViolationsListQuery } from "features/api/contentManagement/contentManagementApiSlice";
import { useGetReportRejectionReasonQuery } from "features/api/reports/reportsSlice";
import { tDecisionType } from "i18n/enums";
import { Violation } from "pages/ControlCenter/ContentManagement/contentManagementUtils/tabSchema";

export const useGetTextForCodeValue = (code: number, dataName: string) => {
  const { data: rejectionReasons } = useGetReportRejectionReasonQuery();
  const { data: offences }: { data: Violation[] } = useGetViolationsListQuery();

  let data;
  let codePropertyName;
  let namePropertyName = "name";

  switch (dataName) {
    case "rejectionReasonID":
      data = rejectionReasons;
      codePropertyName = "code";
      namePropertyName = "name";

      break;
    case "decisions":
      // D-08: the decision-type ladder is a FINITE enum keyed by a stable code.
      // Resolve the DISPLAY label through the lookup helper at render so it
      // reflects the active language, but only when `code` is a known decision
      // type (otherwise fall through to the raw value below).
      if (
        DecisionsTypeArray.some((item) => Number(item.code) === Number(code))
      ) {
        return tDecisionType(code);
      }
      codePropertyName = "code";
      namePropertyName = "name";
      data = DecisionsTypeArray;
      break;
    case "offences":
      data = offences;
      namePropertyName = "name";
      codePropertyName = "id";

      break;
    default:
      return code;
  }

  return (
    data?.find(
      (item: { [key: string]: number | string }) =>
        Number(item[codePropertyName]) === Number(code)
    )?.[namePropertyName] || code
  );
};
